
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Book } from "lucide-react";
import { KnowledgeBaseToggleProps } from "./types";

export const KnowledgeBaseToggle = ({ kb, onToggle, onRemove }: KnowledgeBaseToggleProps) => {
  return (
    <div className="flex items-start justify-between p-3 border rounded-md bg-muted/30">
      <div className="space-y-1">
        <div className="flex items-center gap-2">
          <Book className="h-4 w-4" />
          <span className="font-medium">{kb.name}</span>
          <Switch
            checked={kb.isEnabled}
            onCheckedChange={(checked) => onToggle(checked)}
          />
        </div>
        <div className="text-sm text-muted-foreground">
          {kb.description}
        </div>
        <div className="flex items-center gap-4 text-xs text-muted-foreground mt-1">
          <span>{kb.documentCount} documents</span>
          <span>Updated {kb.lastUpdated.toLocaleDateString()}</span>
        </div>
      </div>
      <Button 
        variant="ghost" 
        size="sm"
        onClick={onRemove}
      >
        Remove
      </Button>
    </div>
  );
};
